import { ReactElement } from 'react';
import clsx from 'clsx';

type InputProps = {
  label?: string;
  isDisabled?: boolean;
  actionElement?: ReactElement;
  noMarginTop?: boolean;
  type?: string;
  idname: string;
  autoComplete?: string;
  isHidden?: boolean;
  min?: string;
  max?: string;
  height?: number;
  placeholder?: string;
  value: string;
  onChnage: (text: string) => void;
};

/**
 * A common Input control component.
 * @param props - Input props.
 * @returns - Returns a react element for input text.
 */
export default function InputBox(props: InputProps): ReactElement {
  const {
    label,
    isDisabled = false,
    actionElement,
    noMarginTop,
    type = 'text',
    idname,
    autoComplete,
    isHidden,
    min,
    max,
    height,
    placeholder,
    value,
    onChnage
  } = props;

  return (
    <div
      style={{ display: isHidden ? 'none' : 'block' }}
      className={`relative w-full ${!noMarginTop && 'mt-4'}`}
    >
      {label && (
        <label htmlFor={idname} className="text-gray-500 dark:text-gray-500 text-sm">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          type={type}
          step={0}
          max={max}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          value={value}
          onChange={(e) => onChnage(e.target.value)}
          min={min}
          placeholder={placeholder}
          disabled={isDisabled}
          autoComplete={autoComplete}
          id={idname}
          style={{ height }}
          className={clsx(
            'w-full block py-1.5 px-3.5 text-base font-normal dark:text-gray-300 placeholder-gray-400 border rounded bg-gray-50 dark:bg-container-500 focus:dark:border-primary-300 focus-within:dark:ring-transparent border-gray-700',
            { 'dark:text-gray-500': isDisabled },
            { 'mt-1': !!label }
          )}
        />
        {actionElement}
      </div>
    </div>
  );
}
